<div class="content-popup">
    <mat-dialog-content>
        <h2>{{ title }}</h2>
        <div [innerHTML]="msg"></div>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
        <button mat-flat-button color="primary" mat-dialog-close cdkFocusInitial (click)="onButtonClick()">{{ buttonName }}</button>
    </mat-dialog-actions>
</div>
